<template>

    <div>

        <div
            v-if="!!company"
            class="position--relative pa-5"
        >

            <h2>{{ company.name }}</h2>

            <h2
                v-can="$roles.BO_WITH_CRUD_RIGHTS"
                class="my-2"
            >
                {{ $t("direct_outputs.new_outpout") }}
            </h2>

            <v-card v-can="$roles.BO_WITH_CRUD_RIGHTS" color="#E1F0FF" class="my-2" flat>

                <div class="border-blue pa-4">

                    <v-form ref="directOutgoingsForm">

                        <v-row>

                            <v-col cols="6">

                            <span class="opacity--70 font-weight-bold">
                                {{ $t("direct_outputs.output_quantity") }}
                            </span>

                                <v-text-field
                                    ref="containerQuantityField"
                                    v-model="directOutgoing.container_quantity"
                                    autofocus
                                    class="mt-2 mb-4"
                                    background-color="#FFFFFF"
                                    dense
                                    outlined
                                    light
                                    hide-details="auto"
                                    :rules="containerQuantityRules()"
                                />

                                <span class="opacity--70 font-weight-bold d-block">
                                {{ $t("direct_outputs.default_services") }}
                            </span>

                                <span class="opacity--70">{{ defaultServices }}</span>

                            </v-col>

                            <v-col cols="6">

                            <span class="opacity--70 font-weight-bold">
                                {{ $t("direct_outputs.include_services") }}
                            </span>

                                <v-row class="mt-0">

                                    <v-col class="d-flex align-start">

                                        <v-subheader class="opacity--70 pr-4 mt-2">
                                            {{ $t("direct_outputs.frosting") }}
                                        </v-subheader>

                                        <v-text-field
                                            v-model="directOutgoing.frosting_quantity"
                                            dense
                                            outlined
                                            light
                                            hide-details="auto"
                                            background-color="#FFFFFF"
                                            class="d-inline-block"
                                            :disabled="!containerQuantityIsValid"
                                            :rules="containerServiceRules(directOutgoing.frosting_quantity)"
                                        />

                                    </v-col>

                                </v-row>

                                <v-row class="mt-4">

                                    <v-col class="d-flex align-start">

                                        <v-subheader class="opacity--70 pr-4 mt-2">
                                            {{ $t("direct_outputs.wrapping") }}
                                        </v-subheader>

                                        <v-text-field
                                            v-model="directOutgoing.filming_quantity"
                                            dense
                                            outlined
                                            light
                                            hide-details="auto"
                                            background-color="#FFFFFF"
                                            :disabled="!containerQuantityIsValid"
                                            :rules="containerServiceRules(directOutgoing.filming_quantity)"
                                        />

                                    </v-col>

                                    <v-col class="d-flex align-start">

                                        <v-subheader class="opacity--70 pr-4 mt-2">
                                            {{ $t("direct_outputs.pallet") }}
                                        </v-subheader>

                                        <v-text-field
                                            v-model="directOutgoing.pallet_quantity"
                                            dense
                                            outlined
                                            light
                                            hide-details="auto"
                                            background-color="#FFFFFF"
                                            :disabled="!containerQuantityIsValid"
                                            :rules="containerServiceRules(directOutgoing.pallet_quantity)"
                                        />

                                    </v-col>

                                </v-row>

                            </v-col>

                        </v-row>

                    </v-form>

                    <v-row>

                        <v-col class="d-flex">

                            <v-btn
                                height="44"
                                color="primary"
                                @click="saveDeliverableLogisticalLot"
                            >
                                {{ $t("direct_outputs.tag") }}
                            </v-btn>

                            <v-spacer/>

                            <v-btn
                                height="44"
                                color="primary"
                                @click="saveDeliveredLogisticalLot"
                            >
                                {{ $t("direct_outputs.validate") }}
                            </v-btn>

                            <v-btn
                                elevation="0"
                                color="secondary"
                                class="brown--text text--darken-1 ml-1"
                                height="44"
                                @click="createDeliveryReport(false)"
                            >
                                {{ $t("direct_outputs.generate_delivery_note") }}
                            </v-btn>

                        </v-col>

                    </v-row>

                </div>

            </v-card>

            <v-row>

                <v-col>

                    <v-card
                        color="primary"
                        dark
                        class="d-flex justify-space-between px-3 py-2 font-weight-bold my-2"
                        flat
                    >
                        <span>{{ $t("direct_outputs.total_sales") }}</span>
                        <span>{{ company.total_costal_day_container_quantity }}</span>
                    </v-card>

                </v-col>

                <v-col>

                    <v-card
                        color="TxtChipsCareful"
                        dark
                        class="d-flex justify-space-between px-3 py-2 font-weight-bold my-2"
                        flat
                    >
                        <span>{{ $t("direct_outputs.total_outputs") }}</span>
                        <span>{{ company.out_costal_day_container_quantity }}</span>
                    </v-card>

                </v-col>

            </v-row>

            <v-card color="#C4C4C4" class="pa-5 my-2" flat>

                <v-row
                    v-if="!!lastDirectOutgoing"
                    class="justify-space-between align-end"
                >

                    <v-col class="pa-1">

                        <div class="font-weight-bold">
                            {{ $t("direct_outputs.last_entry") }}
                        </div>

                        <div>
                        <span class="text-decoration-underline">
                            {{ $t("direct_outputs.output_quantity") }}
                        </span>

                            <span class="font-weight-bold">
                            : {{ lastDirectOutgoing.container_quantity }}
                        </span>
                        </div>

                        <div>
                        <span class="text-decoration-underline">
                            {{ $t("direct_outputs.include_services") }}
                        </span>

                            <span>
                            : {{ $t("direct_outputs.frosting") }}
                        </span>
                            <span class="font-weight-bold">
                            {{ lastDirectOutgoing.frosting_quantity }}
                        </span>

                            <span>
                            - {{ $t("direct_outputs.wrapping") }}
                        </span>
                            <span class="font-weight-bold">
                            {{ lastDirectOutgoing.filming_quantity }}
                        </span>

                            <span>
                            - {{ $t("direct_outputs.pallet") }}
                        </span>
                            <span class="font-weight-bold">
                            {{ lastDirectOutgoing.pallet_quantity }}
                        </span>
                        </div>
                    </v-col>

                    <v-col class="pa-1 text-right">

                        <v-btn
                            v-can="$roles.BO_WITH_CRUD_RIGHTS"
                            :disabled="lastDirectOutgoingEditDisabled"
                            color="black"
                            dark
                            @click="editFormDialog = true"
                        >
                            {{ $t("global.edit") }}
                        </v-btn>

                        <v-btn
                            v-can="$roles.ADMIN"
                            color="primary"
                            class="white--text text--darken-1"
                            @click="getQrCode(null)"
                        >
                            {{ $t("direct_outputs.qr_code") }}
                        </v-btn>

                    </v-col>

                </v-row>

            </v-card>

            <h2 class="mb-3 mt-5">{{ $t("direct_outputs.purchase_summary") }}</h2>

            <v-card flat>

                <v-data-table
                    :headers="containerTotalsBySpecyAndSizeHeaders"
                    :items="containerTotalsBySpecyAndSize"
                    :options.sync="containerOptions"
                    class="alternate-line"
                    hide-default-footer
                    @update:options="getPurchaseSummary"
                >
                    <template #[`item.tag_name`]="{ item }">
                    <span class="font-weight-bold">
                        {{ item.product_specy.tag_name }} / {{ item.product_size.name }}
                    </span>
                    </template>
                </v-data-table>

            </v-card>

            <h2 class="mb-3 mt-5">{{ $t("direct_outputs.outputs_history") }}</h2>

            <v-card flat>

                <v-data-table
                    :headers="directOutgoingHistoriesHeaders"
                    :items="directOutgoingHistories"
                    hide-default-footer
                >

                    <template #[`item.created_at`]="{ item }">

                        {{ $date(item.created_at).format("DD/MM/YYYY HH:mm").replace(":", "h") }}

                    </template>

                    <template #[`item.pdf`]="{ item }">

                        <v-icon
                            v-if="item.type === 'EDIT_DIRECT_OUTGOINGS_REPORT'"
                            size="16"
                            class="pdf rounded pa-1"
                            color="white"
                            @click="getDeliveryReport(item.payload.edited_at)"
                        >
                            mdi-file-pdf
                        </v-icon>

                        <span v-else>-</span>

                    </template>

                    <template #[`item.sticker`]="{ item }">

                        <v-icon
                            v-if="item.payload.delivery_service === 1 && (item.type === 'CREATION' || item.type === 'UPDATE')"
                            size="16"
                            class="print rounded pa-1"
                            color="white"
                            :title="$t('direct_outputs.sticker_print_action')"
                            @click="printSticker(item.historisable_id)"
                        >
                            mdi-printer
                        </v-icon>

                        <span v-else>-</span>

                    </template>

                    <template #[`item.qrcode`]="{ item }">

                        <v-icon
                            v-if="item.type === 'CREATION'"
                            v-can="$roles.ADMIN"
                            size="16"
                            class="qrcode rounded pa-1"
                            color="white"
                            :title="$t('direct_outputs.qr_code_action')"
                            @click="getQrCode(item.payload.code)"
                        >
                            mdi-qrcode-scan
                        </v-icon>

                        <span v-else>-</span>

                    </template>

                </v-data-table>

                <a
                    class="text-decoration-underline d-block text-center pt-4"
                    @click="showHistory = true"
                >
                    {{ $t("direct_outputs.view_all_history") }}
                </a>

            </v-card>

            <edit-form-dialog
                v-if="!!lastDirectOutgoing"
                :visible="editFormDialog"
                action="edit"
                :total-costal-day-container-quantity="company.total_costal_day_container_quantity"
                :out-costal-day-container-quantity="company.out_costal_day_container_quantity"
                :logistical-lot-to-edit="lastDirectOutgoing"
                @printSticker="printSticker"
                @close="closeEditForm"
            />

            <direct-outgoings-histories
                v-if="!!showHistory"
                :visible="showHistory"
                @getDeliveryReport="getDeliveryReport"
                @printSticker="printSticker"
                @close="showHistory = false"
            />

        </div>

        <div class="position--sticky position--bottom border-top">

            <v-card
                elevation="0"
                color="white"
                class="pa-5 d-flex justify-end align-center"
            >

            <span class="font-italic body-2 pr-2 d-inline-block">
                {{ lastReportEditedAt }}
            </span>

                <v-btn
                    elevation="0"
                    color="primary"
                    height="40px"
                    @click="createDeliveryReport(true)"
                >
                    {{ $t("direct_outputs.local_printing") }}
                </v-btn>

                <v-btn
                    elevation="0"
                    color="secondary"
                    class="brown--text text--darken-1 ml-1"
                    height="40px"
                    @click="createDeliveryReport(false)"
                >
                    {{ $t("direct_outputs.generate_delivery_note") }}
                </v-btn>

            </v-card>

        </div>

        <lot-qr-code-modal
            v-if="qrCode"
            :qr-code="qrCode"
            :visible="showQrCodeDialog"
            @close="qrCode = null"
        />

    </div>

</template>

<script>

import DirectOutgoingsHistories from "./CompanyDirectOutgoingsHistories";
import EditFormDialog from "./FormDialog";
import {events} from "../../events";
import dayjs from "dayjs";
import {TYPE} from "vue-toastification";
import Roles from "../../ressources/roles";
import LotQrCodeModal from "../../components/Lots/LotQrCodeModal.vue";

export default {
    name: "CompanyDirectOutgoings",
    components: {
        LotQrCodeModal,
        DirectOutgoingsHistories,
        EditFormDialog
    },
    data() {
        return {
            containerQuantityIsValid: false,
            directOutgoing: {
                buyer_id: null,
                container_quantity: null,
                frosting_quantity: null,
                filming_quantity: null,
                pallet_quantity: null,
            },
            defaultServices: "",
            company: null,
            lastDirectOutgoing: null,
            lastDirectOutgoingEditDisabled: true,

            containerTotalsBySpecyAndSizeHeaders: [
                {
                    text: this.$t("direct_outputs.species_size"),
                    value: "product_specy.tag_name",
                },
                {
                    text: this.$t("direct_outputs.nb_boxes"),
                    align: "center",
                    value: "total_container_quantity",
                },
            ],

            containerOptions: {},
            containerTotalsBySpecyAndSize: [],

            directOutgoingHistoriesHeaders: [
                {
                    text: this.$t("global.date") + " / " + this.$t("global.time"),
                    value: "created_at",
                },
                {
                    text: this.$t("global.actions"),
                    value: "type",
                },
                {
                    text: this.$t("global.author"),
                    value: "by",
                },
                {
                    text: this.$t("direct_outputs.nb_boxes"),
                    value: "payload.container_quantity",
                    align: "center",
                },
                {
                    text: this.$t("global.pdf"),
                    value: "pdf",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("direct_outputs.tag"),
                    value: "sticker",
                    sortable: false,
                    align: "center",
                },
            ],
            directOutgoingHistories: [],

            showHistory: false,
            editFormDialog: false,

            lastReportEditedAt: "",
            reportLoading: false,

            qrCode: null,
            showQrCodeDialog: false,

            appDebug: null,
        };
    },
    watch: {
        company: {
            handler() {
                this.setDefaultServices();
            },
            deep: true,
        },
        directOutgoingHistories: {
            handler() {
                this.setLastReportEditedAt();
            },
            deep: true,
        },
        $route(to, from) {
            if (!!this.$route.params.companyId) {
                this.clearInputs();
                this.$refs.directOutgoingsForm.resetValidation();
                this.$refs.containerQuantityField.focus();
                this.directOutgoing.buyer_id = this.$route.params.companyId;
                this.refreshData();
                this.getPurchaseSummary();
            }
        }
    },
    mounted() {
        if (!!this.$route.params.companyId) {
            this.directOutgoing.buyer_id = this.$route.params.companyId;
            this.refreshData();
            this.getPurchaseSummary();
        }
        if (this.$auth.check(Roles.ADMIN)) {
            this.directOutgoingHistoriesHeaders.push(
                {
                    text: this.$t("direct_outputs.qr_code"),
                    align: "center",
                    value: "qrcode",
                }
            );
        }
        this.getAppDebug();
    },
    methods: {
        async getCompany() {
            let data = await this.$api.company.get(this.$route.params.companyId, {
                params: {
                    includes:
                        "company.total_costal_day_container_quantity," +
                        "company.out_costal_day_container_quantity," +
                        "company.default_lot_management_directives," +
                        "lot_management_directive.sale_type",
                    ...{
                        lot_sale_type_name: "Côtière",
                        lots_in_day_scope: true
                    }
                },
            });

            this.company = data.data.data;
        },
        async getLastDirectOutgoing() {
            this.$api.logisticalLot.getLatest({
                params: {
                    ...{
                        buyer_ids: this.$route.params.companyId
                    }
                },
            }).then((success) => {
                this.lastDirectOutgoing = success.data.data;
                this.lastDirectOutgoingEditDisabled = false;
            }).catch((error) => {
                if (error.response.status === 404) {
                    this.lastDirectOutgoing = {
                        "container_quantity": "X",
                        "frosting_quantity": "X",
                        "filming_quantity": "X",
                        "pallet_quantity": "X"
                    };
                    this.lastDirectOutgoingEditDisabled = true;
                }
            });
        },
        async getPurchaseSummary() {
            let data = await this.$api.lot.getContainerTotalsBySpecyAndSize({
                params: {
                    includes: "lot.product_specy,lot.product_size",
                    ...{
                        buyer_ids: this.$route.params.companyId,
                        lots_in_day_scope: true,
                        mustSort: this.containerOptions.mustSort,
                        multiSort: this.containerOptions.multiSort,
                        sortBy: this.containerOptions.sortBy
                    }
                },
            });

            this.containerTotalsBySpecyAndSize = data.data.data
        },
        async getDirectOutgoingsHistories() {
            let data = await this.$api.history.all({
                params: {
                    history_direct_outgoings_from_buyer_id: this.$route.params.companyId,
                    itemsPerPage: 4,
                    page: 1,
                    sortBy: ["created_at"],
                    sortDesc: [true]
                },
            });

            this.directOutgoingHistories = data.data.data
        },
        async getAppDebug() {
            let data = await axios.get("/api/config/app_debug");
            this.appDebug = data.data.app_debug;
        },
        refreshData() {
            this.getCompany();
            this.getLastDirectOutgoing();
            this.getDirectOutgoingsHistories()
            this.$emit('refreshData');
        },
        setDefaultServices() {

            this.defaultServices = "";

            if (!!this.company && this.company.default_lot_management_directives.length > 0) {

                const costalDefaultDirectives = this.company.default_lot_management_directives.filter(directive => directive.sale_type.name === "Côtière");

                if (costalDefaultDirectives.length > 0) {

                    let defaultServices = [];
                    const costalDefaultDirective = costalDefaultDirectives[0];

                    Object.keys(this.$t('services')).forEach(serviceKey => {
                        if (costalDefaultDirective[serviceKey] === 1) {
                            defaultServices.push(this.$t('services')[serviceKey])
                        }
                    });

                    this.defaultServices = defaultServices.join(' / ');

                }

            }
        },
        setLastReportEditedAt() {
            let lastReportEditedAt = "";

            if (!!this.directOutgoingHistories) {
                const lastReport = this.directOutgoingHistories.find(directOutgoingHistory => directOutgoingHistory.type === "EDIT_DIRECT_OUTGOINGS_REPORT");
                if (!!lastReport) {
                    const lastReportEditedAtDate = dayjs(lastReport.payload.edited_at).format("DD/MM/YY");
                    const lastReportEditedAtHour = dayjs(lastReport.payload.edited_at).format("HH:mm");
                    lastReportEditedAt = this.$tc('direct_outputs.delivery_note_generated_at', null, {
                        date: lastReportEditedAtDate,
                        hour: lastReportEditedAtHour
                    });
                }
            }


            this.lastReportEditedAt = lastReportEditedAt;
        },
        containerQuantityRules() {
            if (this.directOutgoing.container_quantity === null) {
                this.containerQuantityIsValid = false;
                return [this.$tc('validation.required', this.$t('direct_outputs.output_quantity'), {field_name: this.$t('direct_outputs.output_quantity')})];
            }

            if (this.directOutgoing.container_quantity.trim().length <= 0) {
                this.containerQuantityIsValid = false;
                return [this.$tc('validation.required', this.$t('direct_outputs.output_quantity'), {field_name: this.$t('direct_outputs.output_quantity')})];
            }

            if (!!isNaN(this.directOutgoing.container_quantity)) {
                this.containerQuantityIsValid = false;
                return [this.$t('validation.numerical_field')];
            }

            const remainingContainers = this.company.total_costal_day_container_quantity - this.company.out_costal_day_container_quantity;
            if (this.directOutgoing.container_quantity > remainingContainers) {
                this.containerQuantityIsValid = false;
                return [this.$t('validation.outbound_containers')];
            }

            this.containerQuantityIsValid = true;

            return [];
        },
        containerServiceRules(serviceQuantity) {
            if (serviceQuantity !== null) {
                if (!!isNaN(serviceQuantity)) {
                    return [this.$t('validation.numerical_field')];
                }
                if (parseInt(serviceQuantity) > this.directOutgoing.container_quantity) {
                    return [this.$t('validation.outbound_services')];
                }
            }
        },
        async saveDeliverableLogisticalLot() {
            this.directOutgoing.delivery_service = 1;
            let logisticalLot = await this.save();
            if (!!logisticalLot) {
                this.printSticker(logisticalLot.id)
            }
        },
        saveDeliveredLogisticalLot() {
            this.directOutgoing.delivery_service = 0;
            this.save();
        },
        async save() {
            let logisticalLot = null;

            if (this.$refs.directOutgoingsForm.validate()) {

                this.loading = true;

                await this.$api.logisticalLot.create(this.directOutgoing).then((success) => {
                    events.$emit('notificationSuccess', this.$t('direct_outputs.direct_outgoing_successfully_created'));
                    logisticalLot = success.data.data;
                    this.clearInputs();
                    this.$refs.directOutgoingsForm.resetValidation();
                    this.$refs.containerQuantityField.focus();
                    this.refreshData();
                }).finally(() => this.loading = false);

            }

            return logisticalLot;
        },
        async printSticker(logisticalLotId) {
            try {
                await this.$api.logisticalLot.printSticker({id: logisticalLotId});
                events.$emit('notificationSuccess', this.$t('direct_outputs.print_success'));
            } catch (e) {
                events.$emit('notificationFailure', this.$t('direct_outputs.print_error'));
            }
        },
        clearInputs() {
            this.directOutgoing.container_quantity = null;
            this.directOutgoing.frosting_quantity = null;
            this.directOutgoing.filming_quantity = null;
            this.directOutgoing.pallet_quantity = null;
        },
        closeEditForm() {
            this.editFormDialog = false;
            this.refreshData();
        },
        async createDeliveryReport(localPrint) {
            try {
                this.reportLoading = true
                const params = {localPrint: localPrint};
                const response = (await this.$api.logisticalLot.createAndGetDeliveryReport(this.company.id, {params})).data
                if (this.appDebug === true || localPrint === true) {
                    window.open(response.data.file).print();
                } else {
                    events.$emit('notificationSuccess', this.$t('direct_outputs.print_success'));
                }
            } catch (e) {
                events.$emit('notificationFailure', this.$t('direct_outputs.print_error'));
            } finally {
                this.reportLoading = false;
                this.refreshData();
            }
        },
        async getDeliveryReport(editedAt, localPrint = false) {
            try {
                const params = {localPrint: localPrint};
                const response = (await this.$api.logisticalLot.getDeliveryReport(this.company.id, editedAt, {params})).data
                if (this.appDebug === true || localPrint === true) {
                    window.open(response.data.file);
                } else {
                    events.$emit('notificationSuccess', this.$t('direct_outputs.print_success'));
                }
            } catch (e) {
                events.$emit('notificationFailure', this.$t('direct_outputs.print_error'));
            }

        },
        async getQrCode(code = null) {
            if (code === null) {
                code = this.lastDirectOutgoing.code;
            }
            let qrCode = await this.$api.logisticalLot.getQrCode(code);
            this.qrCode = qrCode.data;
            this.showQrCodeDialog = true;
        }
    }
};
</script>

<style lang="scss">

.v-subheader {
    font-family: Lato, sans-serif !important;
    color: rgba(0, 0, 0, 0.87) !important;
    font-size: 16px !important;
    height: auto !important;
}

</style>
